import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import ListingSearchCriteria from './Criteria/ListingSearchCriteria';

interface RouteParams {
  marketSlug: string;
}
const useListingSearchCriteria = () => {
  const { marketSlug } = useParams<RouteParams>();
  const { search: queryString } = useLocation();
  const [urlBuilder, setUrlBuilder] = useState<ListingSearchCriteria>(
    ListingSearchCriteria.fromUrl({ marketSlug, queryString }),
  );

  useEffect(() => {
    setUrlBuilder(ListingSearchCriteria.fromUrl({ marketSlug, queryString }));
  }, [marketSlug, queryString]);

  return cloneDeep(urlBuilder);
};

export default useListingSearchCriteria;
